import { css } from '@emotion/react';
import { Link } from '@remix-run/react';
import { Box, BoxProps } from '@spark-web/box';
import { useTheme } from '@spark-web/theme';
import { PropsWithChildren } from 'react';

type MenuLinkProps = PropsWithChildren<
  {
    name?: string;
    visible?: boolean;
    href: string;
    handleClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
    target?: HTMLAnchorElement['target'];
  } & BoxProps
>;

const MenuLink = ({ visible = true, href, handleClick, children, ...props }: MenuLinkProps) => {
  const theme = useTheme();

  function clickHandler(e: React.MouseEvent<Element, MouseEvent>) {
    handleClick(e);
  }

  if (!visible) {
    return null;
  }

  return (
    <Link
      to={href}
      css={css({
        textDecoration: 'none',
      })}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="start"
        alignItems="center"
        {...props}
        css={css({
          ':hover': {
            cursor: 'pointer',
            backgroundColor: theme.color.background.surfaceMuted,
            textDecoration: 'none',
          },
          ':active': {
            backgroundColor: theme.color.background.surfacePressed,
          },
          textDecoration: 'none',
        })}
        onClick={clickHandler}
      >
        {children}
      </Box>
    </Link>
  );
};

MenuLink.displayName = 'NavItem';

export default MenuLink;
